export default __webpack_public_path__ + "static/media/logo.c80d9ae8.svg";